'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = false;

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
export const loadingSelector = (state: RootState) => state.loading;
